<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group :label="$t('lang.label_password_old')" label-for="input-password-old" label-cols-sm="5">
      <b-form-input @keydown.space.prevent id="input-password-old" ref="oldPassword" required v-model="oldPassword" type="password"></b-form-input>
      <b-form-invalid-feedback>{{ oldPasswordError }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group :label="$t('lang.label_password_new')" label-for="input-password-new" label-cols-sm="5">
      <b-form-input
        @keydown.space.prevent
        id="input-password-new"
        required
        minlength="8"
        v-model="newPassword"
        ref="newPassword"
        v-b-tooltip.hover
        :title="$t('lang.tooltip_user_password')"
        type="password"
      ></b-form-input>
      <b-form-invalid-feedback>{{ passwordError }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group :label="$t('lang.label_password_confirm')" label-for="input-password-confirm" label-cols-sm="5">
      <b-form-input @keydown.space.prevent id="input-password-confirm" ref="confirmPassword" required v-model="confirmPassword" type="password"></b-form-input>
      <b-form-invalid-feedback>{{ confirmPasswordError }}</b-form-invalid-feedback>
    </b-form-group>
    <b-row>
      <b-col sm class="text-right">
        <b-button size="sm" class="mr-4" variant="primary" @click="hideModal">
          {{ $t("lang.label_cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" type="submit">
          {{ $t("lang.label_submit") }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import API from "@/api";
import * as utils from "@/utils";
export default {
  name: "ChangePasswordAfterLogin",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  watch: {
    newPassword: function() {
      this.updatePasswordValidity();
    },
    confirmPassword: function() {
      this.updatePasswordConfirmationValidity();
    },
    oldPassword: function() {}
  },
  computed: {
    passwordError: function() {
      if (utils.isEmpty(this.newPassword)) {
        return this.$t("lang.message_user_password_error_invalid");
      } else if (!utils.isOfSufficientLength(this.newPassword, 8)) {
        return this.$t("lang.message_user_password_length_error");
      } else if (!utils.passwordPatternMatch(this.newPassword)) {
        return this.$t("lang.message_user_password_must_contain_number_letter_and_special_character");
      }
      return "";
    },
    confirmPasswordError: function() {
      if (utils.isEmpty(this.confirmPassword)) {
        return this.$t("lang.message_user_passwordConfirmation");
      } else if (!utils.isEqual(this.confirmPassword, this.newPassword)) {
        return this.$t("lang.message_user_password_error_match");
      } else {
        return "";
      }
    },
    oldPasswordError: function() {
      if (utils.isEmpty(this.oldPassword)) {
        return this.$t("lang.label_placeholder_oldPassword");
      } else {
        return "";
      }
    }
  },
  methods: {
    onSubmit(evt) {
      if (this.validateForm(evt)) {
        this.updatePassword();
      }
    },
    validateForm(evt) {
      var isValid = true;
      var elements = evt.target.elements;
      for (let elem of elements) {
        utils.resetValidityClassFromElement(elem); // remove valid or invalid class before start validating
        if (!elem.validity.valid) {
          elem.classList.add("is-invalid");
          isValid = false;
        }
      }
      return isValid;
    },
    updatePasswordValidity() {
      const passwordElement = this.$refs.newPassword;
      utils.resetValidityClassFromElement(passwordElement.$el);
      passwordElement.setCustomValidity(this.passwordError);
      if (utils.isNotEmpty(this.passwordError)) {
        passwordElement.$el.classList.add("is-invalid");
      }
    },
    updatePasswordConfirmationValidity() {
      const passwordConfirmationElement = this.$refs.confirmPassword;
      utils.resetValidityClassFromElement(passwordConfirmationElement.$el);
      passwordConfirmationElement.setCustomValidity(this.confirmPasswordError);
      if (utils.isNotEmpty(this.confirmPasswordError)) {
        passwordConfirmationElement.$el.classList.add("is-invalid");
      }
    },
    updateOldPasswordValidity() {
      const oldPasswordElement = this.$refs.oldPassword;
      utils.resetValidityClassFromElement(oldPasswordElement.$el);
      oldPasswordElement.setCustomValidity(this.oldPasswordError);
      if (utils.isNotEmpty(this.oldPasswordError)) {
        oldPasswordElement.$el.classList.add("is-invalid");
      }
    },
    updatePassword() {
      API.updateCurrentUserPassword(this.oldPassword, this.newPassword)
        .then(() => {
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_password_change_success"));
          this.hideModal();
        })
        .catch(e => {
          if (e.response.data.message === "Old Password is wrong." || e.response.data.errors[0].field == "oldPassword") {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_password_old_error_invalid"));
          } else {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_password_change_error"));
          }
        });
    },
    hideModal() {
      this.$bvModal.hide("modal-change-password");
    }
  }
};
</script>
